import React, { Component } from 'react'
import { Button } from 'advenio-components'
import styled from 'styled-components'
import Cup from '../CustomButtons/Cup'
import PropTypes from 'prop-types' //eslint-disable-line

const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items:center;
  flex-direction: column;

  width: 100%;
  height: 100%;
  padding: 10px 0;
  overflow-y: scroll;
`

const DrinkContainer = styled.div`
  display: flex;
  justify-content:center;
  align-items:center;
  flex-wrap: wrap;

  width: 80%;
  margin-bottom: 10px;
`

const SaveContainer = styled.div`
 display: flex;
 justify-content:space-between;
 align-items: center;

 width: 100%;
 height: 160px;
 padding: 10px 0;
 background-color: transparent;
`

const Span = styled.span`
  margin-left: 30px;
  color: #4A90E2;
  font-size: 20px;
  @media (max-width: 763px) {
    margin-bottom: 10px;
  }
`

const SaveBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  bottom: 0;
  background-color: white;
  padding: 8px;
  width: 100%;
`

const DrinkLabel = styled.span`
  margin-left: 8px;
  font-size: 24px;
  color: #59a1e4;

`

class Drink extends Component {
  constructor(props) {
    super(props)
    this.state = {
      cups: [
        { estado: 'empty' },
        { estado: 'empty' },
        { estado: 'empty' },
        { estado: 'empty' },
        { estado: 'empty' },
        { estado: 'empty' },
        { estado: 'empty' },
        { estado: 'empty' },
        { estado: 'empty' },
        { estado: 'empty' },
      ],
    }
  }

  componentWillMount = () => {
    if (this.props.info.drink) {
      let value = Number(this.props.info.drink)
      const newState = this.state
      if (value % 1 == 0) {
        newState.cups[value-1].estado = 'full'
      } else {
        newState.cups[Math.floor(value)].estado = 'half'
      }
      for (let i = 0; i < value - 1 ; i++) {
        newState.cups[i].estado = 'full'
      }
      newState.drink = this.props.info.drink
      this.setState(newState)
    }
  }

  onCupClick = (number) => {
    let value = ''
    const newState = this.state
    if (newState.cups[number].estado === 'empty') {
      newState.cups[number].estado = 'half'
    } else if (newState.cups[number].estado === 'half') {
      newState.cups[number].estado = 'full'
    } else {
      newState.cups[number].estado = 'empty'
    }

    for (let i = 0; i < number; i++) {
      newState.cups[i].estado = 'full'
    }

    for (let i = newState.cups.length - 1; i > number; i--) {
      newState.cups[i].estado = 'empty'
    }
    if (newState.cups[number].estado === 'half') {
      value = number + '.5'
    } else if (newState.cups[number].estado === 'empty') {
      value = number
    } else {
      value = number + 1
    }
    this.setState(newState)
    this.setInfo(value)
  }

  setInfo = (value) => {
    const nextState = { ...this.props.info }
    nextState['drink'] = value
    this.setState(nextState, () => this.props.setExtraData(nextState))
  }

  getView = () => {
    return this.state.cups.map((item, index) =>
      (<Cup
        key={index}
        number={index}
        estado={item.estado}
        onChange={(number) => this.onCupClick(number)} />))
  }

  goTo = () => {
    this.props.goToView('eat', '',this.props.category)
  }



  render() {
    return (
      <Container>
        <DrinkContainer>
          {this.getView()}
        </DrinkContainer>
        {this.props.group ? '' :
          <SaveContainer>
            <Span>{this.state.drink ? this.state.drink+' oz' : ''}</Span>
            <Button
              small
              style={this.state.drink
                && this.state.drink !== '0 oz' ?
                { backgroundColor: '#3E72D7', color: '#FFF' } :
                { backgroundColor: '#CCCCCC', color: '#FFF' }}
              onClick={this.goTo}
            >
              {this.state.drink === '0 oz' || this.state.drink == null ? 'No tomó nada' : 'Continuar'}
            </Button>
          </SaveContainer>
        }
        {this.props.group && <SaveBar>
          <DrinkLabel> { this.state.drink && `${this.state.drink} oz`} </DrinkLabel>
          <Button
            small
            style={this.state.drink
              && this.state.drink !== '0 oz' ?
              { backgroundColor: '#3E72D7', color: '#FFF' } :
              { backgroundColor: '#CCCCCC', color: '#FFF' }}
            onClick={this.goTo}
          >
            {this.state.drink === '0 oz' || this.state.drink == null ? 'No tomó nada' : 'Continuar'}
          </Button>
        </SaveBar>}
      </Container>
    )
  }
}

Drink.propTypes = {
  setExtraData: PropTypes.func.isRequired,
  goToView: PropTypes.func.isRequired,
}


export default Drink



// WEBPACK FOOTER //
// ./src/Components/Activity/Drink.jsx